module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.0944be10.woff";